const getEnums = (options = []) => {
  const enums = options.map(item => item.value);
  return enums.length ? { enum: enums } : null;
};

export default getEnums;
